import { updateIntentFees } from "../../services/api";

export const sdkUpdateIntentFees = async ({
  intentId,
  fees,
  lang,
}: {
  intentId: string;
  fees: Array<Fee>;
  lang: string;
}) => {
  try {
    const response = await updateIntentFees({
      fees,
      lang,
      intentId,
    });

    return response.data;
  } catch (error) {
    const errorsList = (await error?.json)?.status?.errors || [];
    return Promise.reject(
      errorsList.reduce((acc, curr) => ({ ...acc, ...curr }), {})
    );
  }
};
